import ColorModeIconDropdown from '@configs/theme/colorSchemeDropDown';
import React, { useState } from 'react';
import logo from '@assets/media/logo.png';
import { Box, useColorScheme } from '@mui/material';
import classNames from 'classnames';
import DropMenus from './inc/DropMenus';
import SideNav from './inc/SideNav';
import router from '@configs/router';

interface Props extends React.PropsWithChildren {
  children: React.ReactElement;
}

const AppNativeLayout: React.FC<Props> = ({ children }) => {
  const { mode, systemMode } = useColorScheme();
  const [sideNavOpen, setSideNavOpen] = useState<boolean>(false);
  return (
    <div className="w-full h-[100dvh] flex flex-col overflow-hidden font-poppins">
      <div className="bg-transparent pt-4 pb-1 px-4 flex items-center w-full h-[7dvh]">
        <div className="h-full w-auto flex">
          <div
            className="h-full w-auto flex aspect-auto cursor-pointer"
            onClick={() => {
              router.navigate({ to: '/home' });
            }}
          >
            <img src={logo} className="size-full" alt="logo" />
          </div>
        </div>
        <div className=" h-full ml-auto mr-2 flex items-center justify-evenly no-select ">
          {/* <DropMenus /> */}
        </div>
        <div className="h-full w-auto aspect-square cursor-pointer">
          <ColorModeIconDropdown />
        </div>
      </div>
      <div className="w-full h-auto flex-1 overflow-hidden flex items-center justify-between md:pl-4 pr-0 md:py-2">
        <div className={'h-full py-2 relative w-auto'}>
          <SideNav open={sideNavOpen} setOpen={setSideNavOpen} />
        </div>
        <div className="h-full w-auto overflow-hidden flex items-center justify-center flex-1">
          {children}
        </div>
      </div>
      <div className=" w-full px-4 items-center bottom-0 h-[3dvh] hidden md:flex justify-center">
        <span className="text-xs">
          &copy; {new Date().getFullYear()} Sapy. All rights reserved.
        </span>
      </div>
    </div>
  );
};

export default AppNativeLayout;
